export class ListDataFilter {
    search!: string;
    TenantId!: number;
    PageSize!: number;
    PageNumber!: number;
}